// * ========================================================================
// * Filter machine accessories by accessory level
// * ========================================================================

'use strict';

import $ from 'jquery';

var filterMachineAccessories = (function() {
  function init(){

    /*
    --- old code for classification levels ---
    $('[data-classification!=basic]').parent('.js-accessories-list').hide();


    $('.js-select-accessory-level').on('change',function(){
      var level = $(this).val();
      var $parent = $(this).parents('.js-accessories-container');
      $parent.find('.js-accessories-list').hide();
      $parent.find('[data-classification='+level+']').parent('.js-accessories-list').show();
    });
    */

    $('.js-select-accessory-level').on('change',function(){
      var accessoriesArr = $(this).val() ? $(this).val().split(',') : [];
      var $accessoryItems = $('.js-accessoryitem');

      $accessoryItems.show();
      if(accessoriesArr.length){
        $accessoryItems.filter(function(i, el){
          if(accessoriesArr.indexOf($(el).attr('data-uuid')) === -1){
            return true;
          }
          else return false;
        }).hide();
      }
    });

    //todo do this properly
    var lang = $('body').attr('data-lang');
    var noProductsText = lang === 'fi' ? 'Ei tuotteita' : 'No products';
    $('.accessorylist').each(function(){
      if($(this).find('li:visible').length === 0){
        $(this).append('<li class="accessorylist__no-products">'+noProductsText+'</li>');
      }
      else {
        $(this).find('.accessorylist__no-products').remove();
      }
    })
  }
  return {
    init: init
  }
})();

module.exports = filterMachineAccessories;
